import React, { Component } from 'react';

import Grid from '@mui/material/Grid2';

import { StringsFeature } from "@models";
import { 
  Character,
  CharacterFeature,
  FightingStyle,
  CharacterFightingStyle,
} from "@dndModels";

import API from "@dndUtilities/system_api";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import SelectFightingStyleBox from "@dndComponents/select/SelectFightingStyleBox";

import LoadingBox from "@components/input/LoadingBox";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";


type Props = {
  character: Character;
  obj: CharacterFeature;
  onChange: (changed: CharacterFeature) => void;
  color: string; 
}

export interface State { 
  fighting_styles: FightingStyle[];
  fighting_style: FightingStyle | null;
  loading: boolean;
}

const api = API.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

class CharacterFightingStyleBox extends Component<Props, State> {
  public static defaultProps = {
    color: ""
  };
  constructor(props: Props) {
    super(props);
    this.state = {
      fighting_styles: [],
      fighting_style: null,
      loading: true
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    this.setState({ loading: true }, () => {
      api.getObjects({ data_type: "fighting_style", character_options: this.props.character.character_options }).then(res => {
        const fighting_styles = res as FightingStyle[];
        const objFinder = fighting_styles.filter(o => o._id === this.props.obj.feature_options[0]);
        let fighting_style: FightingStyle | null = null;
        if (objFinder.length === 1) {
          fighting_style = objFinder[0];
        }
        this.setState({ fighting_styles, fighting_style, loading: false });
      });
    });
  }

  render() {
    if (this.state.loading) {
      return (<LoadingBox />);
    } else if (this.props.obj.feature && this.props.obj.feature.floating_feature) {
      const char_fs = this.props.obj.feature_options[0] as CharacterFightingStyle;
      const char_fighting_style_ids = this.props.character.fighting_styles.map(o => { return o.source_id; });
      const fighting_style_ids = this.props.obj.feature.floating_feature as StringsFeature;
      const filtered = this.state.fighting_styles.filter(o => 
        (fighting_style_ids.strings.includes(o._id)) &&
        (o._id === char_fs.source_id || !char_fighting_style_ids.includes(o._id)));
      return (
        <Grid container spacing={0} direction="column">
          <Grid>
            <SelectFightingStyleBox
              name={this.props.obj.feature.name}
              value={char_fs.source_id}
              color={char_fs.source_id === "" ? "blue" : ""}
              allow_all={false}
              fighting_styles={filtered}
              onChange={ async (id: string) => {
                if (char_fs.source) {
                  char_util.removeCharFeatureBasesFor(this.props.character, char_fs);
                  char_fs.char_feature_bases = [];
                }
                if (this.state.fighting_styles) {
                  const objFinder = this.state.fighting_styles.find(o => o._id === id);
                  let fighting_style: FightingStyle | null = null;
                  if (objFinder) {
                    await api.loadObject(objFinder);
                    fighting_style = objFinder;
                    await char_fs.copy_source({ char: this.props.character, feature_source: fighting_style, parent_cf: this.props.obj });
                  }
                  char_util.repopulateCharFeatureBases(this.props.character).then(() => {
                    this.props.onChange(this.props.obj);
                    this.setState({ fighting_style });
                  });
                }
              }}
            />
          </Grid>
          { this.state.fighting_style &&
            <Grid container spacing={0} direction="column">
              <Grid>
                { this.state.fighting_style.name }
              </Grid>
              <Grid>
                <DisplayStringWithReplacements display_string={ this.state.fighting_style.description } />
              </Grid>
            </Grid>
          }
          {/* <CharacterFeatureSourceInput 
            character={this.props.character}
            // campaign={this.props.campaign}
            source={char_fs}
            onChange={(do_main: boolean) => {
              this.props.onChange(this.props.obj, do_main);
            }}
          /> */}
        </Grid>
      );
    }
    return null;
  }
}

export default CharacterFightingStyleBox;
